import { css, styled } from "styled-components";

const Levels = styled.div`
  display: flex;
  flex-direction: column;

  padding: 1rem;
  gap: 1rem;

  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.surfaceTertiary};
`;

const Level = styled.div<{ $soon: boolean; $clickable: boolean }>`
  display: flex;
  gap: 1rem;
  align-items: center;

  img {
    width: 3rem;
    height: 3rem;
  }

  & > button {
    height: fit-content !important;
  }

  ${({ $soon }) =>
    $soon &&
    css`
      opacity: 0.5;
      user-select: none;
      pointer-events: none;
    `}

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
      & > svg {
        transition: transform 200ms ease;
      }
      &:hover {
        & > svg {
          transform: translateX(5px);
          transition: transform 200ms ease;
        }
      }
    `}
`;

const Text = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  & > span {
    color: ${({ theme }) => theme.colors.black};
    &:first-of-type {
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 140%;
    }
    &:last-of-type {
      font-variant-numeric: stacked-fractions;
      font-size: 1rem;
      font-weight: 700;
      line-height: 120%;
    }
  }
`;

export default {
  Levels,
  Level,
  Text,
};
